module.exports = __webpack_public_path__ + "img/lunch-launch-mockup.6bf77893.png";